<div class="" *ngIf="isUserLogin">
    <loading-contents *ngIf="websites == null"></loading-contents>
    <div class="main-contents" *ngIf="websites != null">
        <div class="dashborad padding-top-30">
            <div class="container">
                <dashboard-header></dashboard-header>                
                <div class="row">
                    <div class="col-lg-6 padding-bottom-15">
                        <h5>Web Development ({{total}})</h5>
                    </div>
                    <div class="col-lg-3 padding-bottom-15">
                        <button class="btn btn-outline-light btn-sm" (click)="addNewItem()">Add Website</button>
                    </div>
                    <div class="col-lg-3 padding-bottom-15 filter">
                        <form [formGroup]="searchForm" class="form-inline search-form">
                            <input [formControl]="searchControl" class="form-control form-control-sm search" type="text" placeholder="Search..." aria-label="Search"><fa-icon [icon]="faSearch"></fa-icon>
                        </form>
                    </div>
                </div>
                <div class="row" *ngIf="seachItemList">
                    <div class="col-lg-3 col-xs-6 col-md-3 col-sm-6 padding-bottom-15" *ngFor="let item of seachItemList">
                        <div class="card">
                            <div class="card-image">
                            <img src="../../assets/images/websites/thumbnail/{{item.thumbnail_image}}" class="card-img-top" alt="{{item.title}}">
                            </div>                            
                            <div class="card-body" (click)="onSelect(item)">
                                <div class="body-wrapper">                                
                                    <div class="siteTitle">
                                    <h6>{{item.title}}</h6>
                                    <span>Build by: {{item.item_category}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-6 col-xs-6 col-md-6 col-sm-6">
                                <button class="btn btn-outline-light btn-sm" (click)="editItem(item)">Edit</button>
                            </div>
                            <div class="col-lg-6 col-xs-6 col-md-6 col-sm-6">
                                <button class="btn btn-outline-danger btn-sm" type="button" data-toggle="modal" attr.data-target="#item-{{item.url}}">Delete</button>
                                <!-- Modal -->
                                <div class="modal fade" id=item-{{item.url}} tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                                    <div class="modal-dialog modal-dialog-centered" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                        <h5 class="modal-title" id="centerTitle">Delete Post: {{item.title}}</h5>
                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                        </div>
                                        <div class="modal-body">
                                            <div class="card-image padding-bottom-15">
                                                <img src="../../assets/images/websites/thumbnail/{{item.thumbnail_image}}" class="card-img-top" alt="{{item.title}}">
                                            </div> 
                                            <p>Are your sure you want to permanently remove "{{item.title}}" post?</p>
                                        </div>
                                        <div class="modal-footer">
                                            <div class="row">
                                                <div class="buttons col-lg-6">
                                                    <button type="button" class="btn btn-outline-danger" data-dismiss="modal" (click)="deleteItem(item)">Yes</button>
                                                </div>
                                                <div class="buttons col-lg-6">
                                                    <button type="button" class="btn btn-outline-light" data-dismiss="modal">Cancel</button>
                                                </div>                                               
                                            </div>                                        
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="websites && !seachItemList">
                    <div class="col-lg-3 col-xs-6 col-md-3 col-sm-6 padding-bottom-15" *ngFor="let item of websites">
                        <div class="card">
                            <div class="card-image">
                            <img src="../../assets/images/websites/thumbnail/{{item.thumbnail_image}}" class="card-img-top" alt="{{item.title}}">
                            </div>                            
                            <div class="card-body" (click)="onSelect(item)">
                                <div class="body-wrapper">                                
                                    <div class="siteTitle">
                                    <h6>{{item.title}}</h6>
                                    <span>Build by: {{item.item_category}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-6 col-xs-6 col-md-6 col-sm-6">
                                <button class="btn btn-outline-light btn-sm" (click)="editItem(item)">Edit</button>
                            </div>
                            <div class="col-lg-6 col-xs-6 col-md-6 col-sm-6">
                                <button class="btn btn-outline-danger btn-sm" type="button" data-toggle="modal" attr.data-target="#item-{{item.url}}">Delete</button>
                                <!-- Modal -->
                                <div class="modal fade" id=item-{{item.url}} tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                                    <div class="modal-dialog modal-dialog-centered" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                        <h5 class="modal-title" id="centerTitle">Delete Post: {{item.title}}</h5>
                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                        </div>
                                        <div class="modal-body">
                                            <div class="card-image padding-bottom-15">
                                                <img src="../../assets/images/websites/thumbnail/{{item.thumbnail_image}}" class="card-img-top" alt="{{item.title}}">
                                            </div> 
                                            <p>Are your sure you want to permanently remove "{{item.title}}" post?</p>
                                        </div>
                                        <div class="modal-footer">
                                            <div class="row">
                                                <div class="buttons col-lg-6">
                                                    <button type="button" class="btn btn-outline-danger" data-dismiss="modal" (click)="deleteItem(item)">Yes</button>
                                                </div>
                                                <div class="buttons col-lg-6">
                                                    <button type="button" class="btn btn-outline-light" data-dismiss="modal">Cancel</button>
                                                </div>                                               
                                            </div>                                        
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="" *ngIf="!isUserLogin">
    <app-slider></app-slider>
    <div class="loading">
        <div class="wrapper padding-top-30">
            <div class="container">
                <p>Oops, The page you are looking for can't be found!</p>
                <div class="missing-page">
                    <span class="side">4</span>
                    <span class="taiji-icon"></span>
                    <span class="side">4</span>
                </div>
                <p>Loading...</p>
            </div>
        </div>
    </div>
    <div class="socail-media padding-top-30">
        <div class="container">
            <div class="row">
                <div class="col-lg-6 col-xs-6 col-md-6 col-sm-6">
                    <instagram-post></instagram-post>
                </div>
                <div class="col-lg-6 col-xs-6 col-md-6 col-sm-6">
                    <tumblr-posts></tumblr-posts>
                </div>
            </div>
        </div>
    </div>
</div>
